import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { Button, Card, CardContent, Typography } from '@mui/material'
import { Link } from '@tanstack/react-router'
import styles from './NoAccess.module.scss'

const homeName: Readonly<Record<string, string>> = { '/events': 'Events', '/sessions': 'Outreach', '/check-in': 'Check-in', '/reports': 'Reports', '/team': 'Permissions', '/settings': 'Settings' }

/** Shown in place of a screen someone doesn't have permission for. */
export function NoAccess({ home }: Readonly<{ home: string }>) {
  return (
    <Card className={styles.card} component="section" aria-labelledby="no-access-title">
      <CardContent className={styles.content}>
        <LockOutlinedIcon className={styles.icon} aria-hidden="true" />
        <Typography id="no-access-title" component="h1" variant="h6">You don’t have access to this</Typography>
        <Typography color="text.secondary">If you need it, ask someone who manages permissions to give it to you.</Typography>
        <Button component={Link} to={home} variant="contained">Go to {homeName[home] ?? 'the app'}</Button>
      </CardContent>
    </Card>
  )
}
